import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  TextField,
  InputAdornment,
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { ApiUrl } from "../../utils/ApiUrl";
import SearchIcon from "@mui/icons-material/Search";
import xIcon from "../../images/xIcon.png";
import { Link } from "react-router-dom";

const HotelList = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [destinationList, setDestinationList] = useState<any>([]);
  const [searchVal, setSearchVal] = useState("");
  const [tableText, setTableText] = useState("Loading...");

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  type Order = "asc" | "desc";

  function getComparator<Key extends keyof any>(
    order: Order,
    orderBy: Key
  ): (
    a: { [key in Key]: number | string },
    b: { [key in Key]: number | string }
  ) => number {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  // This method is created for cross-browser compatibility, if you don't
  // need to support IE11, you can use Array.prototype.sort() directly
  function stableSort<T>(
    array: readonly T[],
    comparator: (a: T, b: T) => number
  ) {
    const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  const GetDestinationList = () => {
    return axios
      .request({
        method: "GET",
        url: `${ApiUrl}/scheduleDestinations/`,
        params: {
          // Filter: JSON.stringify({ ScheduleId: 1 }),
          PageNumber: 1,
          PageSize: 1000,
          Search: searchVal,
        },
      })
      .then((res) => {
        if (res.data.length > 0) {
          // Trim duplicates destination before return to Destination List
          setDestinationList(
            res.data.filter(
              (v: any, i: any, a: any) =>
                a.findIndex((v2: any) =>
                  ["destination"].every((k) => v2[k] === v[k])
                ) === i
            )
          );
        } else {
          setTableText(`There is no record found for keyword "${searchVal}"`);
        }
      })
      .catch((error) => {
        setTableText(`There is no record found for keyword "${searchVal}"`);
        console.log(error);
      });
  };

  useEffect(() => {
    setPage(0);
    setTableText("Loading...");
    setDestinationList([]);
    let timerFunc = setTimeout(() => {
      GetDestinationList();
    }, 750);

    return () => clearTimeout(timerFunc);
  }, [searchVal]);

  return (
    <div className="bg-white md:rounded-xl drop-shadow-xl h-[60rem] lg:rounded-[20px] z-0">
      <div className="md:p-10 p-5">
        <Link to={"/"} onClick={() => localStorage.clear()}>
          <div className="flex justify-end">
            <img src={xIcon} className="w-[12px]"></img>
          </div>
        </Link>
        <div className="flex flex-col my-[20px] md:px-[100px] lg:px-[150px] items-center space-y-14 text-lg">
          <div className="font-bold text-3xl text-center">
            City Shuttle Destinations Hotel List
          </div>
          <div className="flex flex-col justify-start items-start space-y-2 text-justify ">
            <TextField
              fullWidth
              id="search"
              name="search"
              size="small"
              placeholder="Search"
              onChange={(event) => setSearchVal(event.target.value.trim())}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            <Paper
              className="md:w-[500px] w-[300px]"
              sx={{ overflow: "hidden" }}
            >
              <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        key={"hotelName"}
                        align={"center"}
                        style={{ minWidth: 170 }}
                      >
                        Hotel Name
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {destinationList.length > 0 ? (
                      stableSort(
                        destinationList,
                        getComparator("asc", "destination")
                      )
                        .sort()
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row: any) => {
                          return (
                            <TableRow hover tabIndex={-1} key={row.id}>
                              <TableCell key={row.id} align={"left"}>
                                {row.destination}
                              </TableCell>
                            </TableRow>
                          );
                        })
                    ) : (
                      <TableRow hover tabIndex={-1}>
                        <TableCell align={"left"}>{tableText}</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[]}
                component="div"
                count={destinationList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelList;
